import BaseApi from "@/api/baseApi";

export default {
  addOrUpdate(form) {
    return BaseApi.post('api-master-data/transporter/v1', form);
  },
  delete(id) {
    return BaseApi.delete(`api-master-data/transporter/v1/${id}`);
  },
  fetch() {
    return BaseApi.get('api-master-data/transporter/v1');
  },
}
